// Currency formatting
import { Decimal } from 'decimal.js';

export const formatCurrency = (value) => {
  if (!value && value !== 0) return 'N/A';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

// Tax ID validation
export const validateTaxId = (value) => {
  // EIN format: XX-XXXXXXX
  const einRegex = /^\d{2}-\d{7}$/;
  // SSN format: XXX-XX-XXXX
  const ssnRegex = /^\d{3}-\d{2}-\d{4}$/;
  
  return einRegex.test(value) || ssnRegex.test(value);
};

// Date formatting
export const formatDate = (date: Date | string): string => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Format percentage
export const formatPercentage = (value: number): string => {
  if (!value && value !== 0) return '0%';
  return `${(value * 100).toFixed(1)}%`;
};

// Add new accounting-specific formatters
export const formatAccountingAmount = (amount) => {
  if (!amount && amount !== 0) return '';
  const value = Math.abs(amount);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

export const formatDebitCredit = (amount) => {
  if (!amount && amount !== 0) return '';
  return amount > 0 ? formatAccountingAmount(amount) : '';
}; 